import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ProductCardOnDisplayInShowroom from 'components/consumer/product-card/ProductCardOnDisplayInShowroom';
import Link from 'components/consumer/Link';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useProductCardContext from 'data-hooks/useProductCardContext';
import ProductCardLabelUI from 'components/consumer/product-card/ProductCardLabel/ProductCardLabelUI';
import ProductCardNameUI from 'components/consumer/product-card/ProductCardNameUI';
import ProductCardPriceUI from 'components/consumer/product-card/ProductCardPrice/ProductCardPriceUI';
import IconQuickship from 'components/icons/iconQuickship';
import { colorGrayLight2 } from 'styles/layout/colors';
import useAllProductClearanceStock from 'data-hooks/useAllProductClearanceStock';
import ProductCardSwatchesNewUI from 'components/consumer/product-card/ProductCardSwatches/ProductCardSwatchesNewUI';
import ProductCardOptionsUI from 'components/consumer/product-card/ProductCardOptions/ProductCardOptionsUI';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import useCloseSearch from 'global-state/isSearchOpen/useCloseSearch';
import ProductCardPhotoSquare from './components/ProductCardPhotoSquare';
import ProductCardFavoriteButton from './components/ProductCardFavoriteButton';
import { isStyleCategoryPrefix } from '../../category-page-algolia/categoryPageSlugUtils';
const ProductCardStaticUI = t0 => {
  const $ = _c(94);
  const {
    analyticsComponentName,
    disableImageLazyLoading,
    disablePDPPrefetch: t1,
    prioritizeImage,
    hidden,
    enableMobileCarousel,
    onClick,
    isHotspotCard: t2,
    layout
  } = t0;
  const disablePDPPrefetch = t1 === undefined ? false : t1;
  const isHotspotCard = t2 === undefined ? false : t2;
  const history = useHistory();
  const location = useLocation();
  const {
    id,
    image,
    isClearance,
    isOutOfStock,
    label: t3,
    loading,
    minPrice,
    name,
    originalPrice,
    path,
    position,
    price,
    productFamily,
    productLabel,
    productType,
    quickship,
    showAttributes,
    showProductLabel,
    showShowroomInfo,
    showStockInfo,
    showSwatches,
    sku,
    slug,
    upholsteryThumbnail,
    variantsToShow
  } = useProductCardContext();
  const label = t3 === undefined ? "" : t3;
  let t4;
  if ($[0] !== path || $[1] !== slug) {
    t4 = path && String(path) !== "null" && path.startsWith("/") ? path : slug ? `/products/${slug}/` : "#";
    $[0] = path;
    $[1] = slug;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const safePath = t4;
  const currentPage = useUserCurrentPageType();
  const {
    data: clearanceData
  } = useAllProductClearanceStock();
  const closeSearch = useCloseSearch();
  const pathnameSegments = location?.pathname?.split("/").filter(Boolean) ?? [];
  const isStyleCategoryPage = pathnameSegments.length === 2 && isStyleCategoryPrefix(pathnameSegments[0]);
  const shouldDisablePDPPrefetch = disablePDPPrefetch || currentPage === avo.Location.CATEGORY_PAGE || isStyleCategoryPage;
  const isFlashSale = Boolean(clearanceData?.[id]?.[sku]?.flashSale);
  let t5;
  if ($[3] !== analyticsComponentName || $[4] !== currentPage || $[5] !== id || $[6] !== isClearance || $[7] !== isFlashSale || $[8] !== label || $[9] !== name || $[10] !== originalPrice || $[11] !== position || $[12] !== price || $[13] !== productFamily || $[14] !== productType || $[15] !== quickship || $[16] !== sku) {
    t5 = () => {
      avo.productClicked({
        category: productType,
        component: analyticsComponentName,
        contentIds: [(sku ?? "").split("-")[0]],
        currency: "USD",
        fullPrice: parseFloat(originalPrice),
        isClearance,
        location: currentPage,
        name,
        position,
        price: parseFloat(price),
        productFamily,
        productId: id,
        quantity: 1,
        quickship,
        sku,
        variant: label,
        isFlashSale
      });
    };
    $[3] = analyticsComponentName;
    $[4] = currentPage;
    $[5] = id;
    $[6] = isClearance;
    $[7] = isFlashSale;
    $[8] = label;
    $[9] = name;
    $[10] = originalPrice;
    $[11] = position;
    $[12] = price;
    $[13] = productFamily;
    $[14] = productType;
    $[15] = quickship;
    $[16] = sku;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const trackProductClicked = t5;
  let t6;
  if ($[18] !== closeSearch || $[19] !== history || $[20] !== image || $[21] !== minPrice || $[22] !== name || $[23] !== onClick || $[24] !== originalPrice || $[25] !== price || $[26] !== safePath || $[27] !== trackProductClicked) {
    t6 = event => {
      trackProductClicked(event);
      if (event.ctrlKey || event.metaKey) {
        return;
      }
      event.preventDefault();
      onClick?.();
      closeSearch();
      if (safePath.startsWith("/modular/") || safePath.startsWith("/modulars/")) {
        window.location.href = safePath;
      } else {
        if (safePath !== "#") {
          history.push(safePath, {
            image,
            minPrice,
            name,
            originalPrice,
            price
          });
        }
      }
    };
    $[18] = closeSearch;
    $[19] = history;
    $[20] = image;
    $[21] = minPrice;
    $[22] = name;
    $[23] = onClick;
    $[24] = originalPrice;
    $[25] = price;
    $[26] = safePath;
    $[27] = trackProductClicked;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  const onProductClick = t6;
  const labelStr = label != null ? String(label) : "";
  let t7;
  if ($[29] !== labelStr) {
    t7 = labelStr.split(",")?.[0] ?? "";
    $[29] = labelStr;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  const shortLabel = t7;
  let t8;
  if ($[31] !== labelStr) {
    t8 = labelStr.split(",").slice(1).map(_temp);
    $[31] = labelStr;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  const otherLabels = t8;
  let t9;
  if ($[33] !== hidden || $[34] !== isHotspotCard) {
    t9 = classNames("rounded-sm relative text-gray [transition:all_0.25s_ease-in-out] pb-2 md:pb-0", {
      "!rounded-lg !p-2.5": isHotspotCard
    }, {
      hidden
    });
    $[33] = hidden;
    $[34] = isHotspotCard;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  const t10 = shouldDisablePDPPrefetch ? false : undefined;
  let t11;
  if ($[36] !== disableImageLazyLoading || $[37] !== enableMobileCarousel || $[38] !== prioritizeImage) {
    t11 = <ProductCardPhotoSquare disableImageLazyLoading={disableImageLazyLoading} prioritizeImage={prioritizeImage} enableMobileCarousel={enableMobileCarousel} />;
    $[36] = disableImageLazyLoading;
    $[37] = enableMobileCarousel;
    $[38] = prioritizeImage;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== name) {
    t12 = <ProductCardNameUI name={name} />;
    $[40] = name;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  const t13 = !!price && (!!originalPrice && originalPrice !== price || !!minPrice && minPrice !== price);
  const t14 = originalPrice ?? price;
  let t15;
  if ($[42] !== loading || $[43] !== minPrice || $[44] !== price || $[45] !== t13 || $[46] !== t14) {
    t15 = <ProductCardPriceUI hasDiscount={t13} loading={loading} minPrice={minPrice} originalPrice={t14} salePrice={price} />;
    $[42] = loading;
    $[43] = minPrice;
    $[44] = price;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== t12 || $[49] !== t15) {
    t16 = <div className="min-h-[4.6rem] min-w-0">{t12}{t15}</div>;
    $[48] = t12;
    $[49] = t15;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== quickship || $[52] !== showStockInfo) {
    t17 = showStockInfo && !!quickship && <div className="text-xs flex items-center text-gray-light1 mt-1 gap-2"><IconQuickship color={colorGrayLight2} width={18} height={12} /><span>Ready to ship</span></div>;
    $[51] = quickship;
    $[52] = showStockInfo;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== isOutOfStock || $[55] !== showStockInfo) {
    t18 = showStockInfo && !!isOutOfStock && <div className="text-xs text-red mt-1">Out of stock</div>;
    $[54] = isOutOfStock;
    $[55] = showStockInfo;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== t17 || $[58] !== t18) {
    t19 = <div className="shrink-0 xl:mt-5 xl:ml-auto">{t17}{t18}</div>;
    $[57] = t17;
    $[58] = t18;
    $[59] = t19;
  } else {
    t19 = $[59];
  }
  let t20;
  if ($[60] !== t16 || $[61] !== t19) {
    t20 = <div className="flex flex-col gap-1 xl:flex-row xl:items-start xl:gap-x-2 xl:gap-y-0 w-full px-[10px] md:px-0 pb-2 relative">{t16}{t19}</div>;
    $[60] = t16;
    $[61] = t19;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  let t21;
  if ($[63] !== otherLabels || $[64] !== shortLabel || $[65] !== showAttributes || $[66] !== upholsteryThumbnail) {
    t21 = showAttributes && (!!shortLabel || !!otherLabels.length) && <ProductCardOptionsUI fabricSelectedOption={{
      label: shortLabel,
      image: upholsteryThumbnail
    }} productOptions={otherLabels} />;
    $[63] = otherLabels;
    $[64] = shortLabel;
    $[65] = showAttributes;
    $[66] = upholsteryThumbnail;
    $[67] = t21;
  } else {
    t21 = $[67];
  }
  let t22;
  if ($[68] !== productLabel || $[69] !== showProductLabel) {
    t22 = showProductLabel && !!productLabel && <ProductCardLabelUI label={productLabel} />;
    $[68] = productLabel;
    $[69] = showProductLabel;
    $[70] = t22;
  } else {
    t22 = $[70];
  }
  let t23;
  if ($[71] !== layout) {
    t23 = layout !== "mini" && <div className="absolute top-5 right-5 group-hover:opacity-100"><ProductCardFavoriteButton /></div>;
    $[71] = layout;
    $[72] = t23;
  } else {
    t23 = $[72];
  }
  let t24;
  if ($[73] !== name || $[74] !== onProductClick || $[75] !== safePath || $[76] !== t10 || $[77] !== t11 || $[78] !== t20 || $[79] !== t21 || $[80] !== t22 || $[81] !== t23) {
    t24 = <Link onClick={onProductClick} to={safePath} prefetch={t10} aria-label={name} className="block hover:!no-underline group/product-card">{t11}{t20}{t21}{t22}{t23}</Link>;
    $[73] = name;
    $[74] = onProductClick;
    $[75] = safePath;
    $[76] = t10;
    $[77] = t11;
    $[78] = t20;
    $[79] = t21;
    $[80] = t22;
    $[81] = t23;
    $[82] = t24;
  } else {
    t24 = $[82];
  }
  let t25;
  if ($[83] !== onProductClick || $[84] !== showSwatches || $[85] !== variantsToShow?.length) {
    t25 = showSwatches && variantsToShow?.length >= 2 && <TabletAndDesktopOnly><div className="max-[767px]:hidden"><ProductCardSwatchesNewUI onProductClick={onProductClick} /></div></TabletAndDesktopOnly>;
    $[83] = onProductClick;
    $[84] = showSwatches;
    $[85] = variantsToShow?.length;
    $[86] = t25;
  } else {
    t25 = $[86];
  }
  let t26;
  if ($[87] !== showShowroomInfo) {
    t26 = showShowroomInfo && <div className="mt-2"><ProductCardOnDisplayInShowroom /></div>;
    $[87] = showShowroomInfo;
    $[88] = t26;
  } else {
    t26 = $[88];
  }
  let t27;
  if ($[89] !== t24 || $[90] !== t25 || $[91] !== t26 || $[92] !== t9) {
    t27 = <div className={t9}>{t24}{t25}{t26}</div>;
    $[89] = t24;
    $[90] = t25;
    $[91] = t26;
    $[92] = t9;
    $[93] = t27;
  } else {
    t27 = $[93];
  }
  return t27;
};
ProductCardStaticUI.propTypes = {
  analyticsComponentName: PropTypes.string,
  disablePDPPrefetch: PropTypes.bool,
  hidden: PropTypes.bool,
  isHotspotCard: PropTypes.bool,
  enableMobileCarousel: PropTypes.bool,
  onClick: PropTypes.func,
  layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom'])
};
export default ProductCardStaticUI;
function _temp(item) {
  return item.trim();
}